<template>
  <div class="search_page">
    <div class="search_header">
      <div class="search_result_total">
        <div class="query_text_search">{{ keySearch }}</div>
        <div v-show="!showLoading" class="number_search_result">{{ totalResults }} Results for <span style="color: #5076de;">"{{ keySearch }}"</span></div>
      </div>
      <div class="search_sort_by">
        <div>Sort By: </div>
        <div :class="'community_dropdown' + (showFilterDown ? ' show' : '')">
          <div class="community_dropdown_main" @click="toggleFilterDropdown()">
            <span id="dropdown_hub_leaderboard">{{ filterSortText }}</span>
            <img :data-src="contentCloudFront('/assets/v4/community/com-arrow.png')" class="lazyload">
          </div>
          <div class="community_dropdown_items">
            <div class="community_dropdown_item" @click="changeSortFilter('most_relevant')">Most Relevant</div>
            <div class="community_dropdown_item" @click="changeSortFilter('newest')">Newest</div>
          </div>
        </div>
      </div>
    </div>
    <div class="community_event_bar" />
    <div class="search_content">
      <div class="search_filter_left">
        <div class="search_filter_container">
          <div class="filter_text">Filters</div>
          <div class="community_event_bar" />
        </div>
        <filter-bar :origin="'webpage'" :filter-data="getFilterData" :on-filter="handleFilterInPage" />
      </div>
      <div class="search_content_body">
        <div v-if="Object.keys(listFilterSelected).length > 0" class="filter_section">
          <div class="filter_tag">
            <div v-for="(filterSelected, filterKey) in listFilterSelected" :key="filterKey" class="filter_tag_names">
              {{ filterSelected }}<span class="close_filter" @click="closeFilter(filterKey)">X</span>
            </div>
          </div>
          <div class="clear_filter" @click="clearFilter()">Clear Filters</div>
        </div>
        <div class="results">
          <img v-if="showLoading" class="loading_img" :src="contentCloudFrontWithVersion('/ellipsis.svg')" style="display: block; margin: 0 auto; width: 100px">
          <template v-else>
            <div v-if="tournaments.length === 0 && news.length === 0 && hubs.length === 0" class="search_notice"><i>No Results!</i></div>
            <template v-else>
              <div v-if="tournaments.length > 0" :class="'tournament_results ' + (news.length > 0 ? 'has_border' : '')">
                <div v-for="(tournament, index) in tournaments" :key="'tournament_' + index">
                  <event-card :event="tournament" />
                </div>
              </div>
              <div v-if="news.length > 0" :class="'newsletter_results' + (hubs.length > 0 ? ' has_border' : '')">
                <div v-for="(n, index) in news" :key="'news_' + index" class="news-card">
                  <news-card :news="n" />
                </div>
              </div>
              <div v-if="hubs.length > 0" class="hub_results">
                <div v-for="(hub, index) in hubs" :key="'hubs_' + index" class="hub-card">
                  <hub-card :hub="hub" />
                </div>
              </div>
            </template>
          </template>
        </div>
        <div v-if="tournaments.length > 0 || news.length > 0 || hubs.length > 0" class="search_pagination">
          <div class="search_page_item prev_item" :class="{disabled: currentPage <= 1}" @click="changePreviousPage()"><span>&lt;</span> Prev</div>
          <div v-for="pageValue in totalPages" :key="pageValue" @click="changePage(pageValue)">
            <div v-if="checkPageDisplay(pageValue)" class="search_page_item" :class="{active: pageValue === currentPage}">{{ checkPageDisplay(pageValue) }}</div>
          </div>
          <div class="search_page_item next_item" :class="{disabled: currentPage >= totalPages}" @click="changeNextPage()">Next <span>></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import NewsCard from './news-card';
import HubCard from './hub-card';
import FilterBar from './filter-bar';
import EventCard from '../../components/events/EventCard';
import { EventBus, SEARCH_HANDLE_SEARCH, SEARCH_UPDATE_QUERY } from '../../event-bus';

export default {
  components: { FilterBar, NewsCard, HubCard, EventCard },
  mixins: [component],
  props: {
    filterData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showFilterDown: false,
      showLoading: false,
      tournaments: [],
      hubs: [],
      news: [],
      users: [],
      totalResults: 0,
      totalPages: 0,
      currentPage: 1,
      startFilter: false,
      filterSortText: 'Newest',
      filterSort: 'newest',
      tournamentFeatured: 1,
      tournamentType: [],
      tournamentPlatform: [],
      hubType: [],
      enabledNewsFilter: 1,
      number_max_page: 10,
      listTextFilter: {
        tournamentFeatured: 'Featured',
        tournamentPlatform: {
          pc: 'PC',
          xbox: 'Xbox',
          ps4: 'Playstation',
          mobile: 'Switch',
        },
        tournamentType: {
          solos: 'Solos/1v1',
          duos: 'Duos/2v2',
          trios: 'Trios/3v3',
          squads: 'Quads/4v4',
          others: '5v5 and up',
        },
        hubType: {
          highschool: 'High School',
          college: 'College',
          // gaming: 'Game Hub',
        },
        enabledNewsFilter: 'News',
      },
      listFilterSelected: {},
      keySearch: '',
      listTotalResults: [],
    };
  },
  computed: {
    getFilterData() {
      return {
        featured: this.tournamentFeatured ? 1 : 0,
        platform: this.tournamentPlatform,
        news_filter: this.enabledNewsFilter ? 1 : 0,
        tournament_type: this.tournamentType,
        hub_type: this.hubType,
      };
    },
  },
  async created() {
    this.initFilterValue();
    this.handleSelectFilter();
    await this.handleSearch(true);
    EventBus.$on(SEARCH_HANDLE_SEARCH, (keySearch) => {
      this.keySearch = keySearch;
      this.currentPage = 1;
      this.handleSearch();
    });
  },
  beforeDestroy() {
    EventBus.$off(SEARCH_HANDLE_SEARCH);
  },
  methods: {
    initFilterValue() {
      if (!this.startFilter) {
        this.keySearch = typeof this.filterData['query'] !== 'undefined' ? this.filterData['query'] : '';
        EventBus.$emit(SEARCH_UPDATE_QUERY, this.keySearch);
        this.tournamentFeatured = typeof this.filterData['featured'] !== 'undefined' ? parseInt(this.filterData['featured']) : 1;
        this.tournamentType = typeof this.filterData['tournament_type'] !== 'undefined' ? this.filterData['tournament_type'] : [];
        this.tournamentPlatform = typeof this.filterData['platform'] !== 'undefined' ? this.filterData['platform'] : [];
        this.hubType = typeof this.filterData['hub_type'] !== 'undefined' ? this.filterData['hub_type'] : [];
        if (this.hubType.length === 0) {
          this.hubType = ['all', 'highschool', 'college'];
          this.filterData['hub_type'] = this.hubType;
        }
        this.enabledNewsFilter = typeof this.filterData['news_filter'] !== 'undefined' ? parseInt(this.filterData['news_filter']) : 1;
      }
    },
    handleSelectFilter() {
      // add feature to list filter
      if (this.tournamentFeatured === 1) {
        this.listFilterSelected['tournamentFeatured'] = this.listTextFilter['tournamentFeatured'];
      } else {
        delete this.listFilterSelected['tournamentFeatured'];
      }
      // add tournament type to list filter
      if (this.tournamentType.length > 0) {
        var listTournamentType = Object.keys(this.listTextFilter['tournamentType']);
        for (var i = 0; i < listTournamentType.length; i++) {
          var tournamentType = listTournamentType[i];
          if (this.tournamentType.indexOf(tournamentType) > -1) {
            this.listFilterSelected['tournamentType.' + tournamentType] = this.listTextFilter['tournamentType'][tournamentType];
          } else {
            delete this.listFilterSelected['tournamentType.' + tournamentType];
          }
        }
      } else {
        this.deleteAllKeyObject(this.listTextFilter['tournamentType'], 'tournamentType');
      }
      // add tournament platform to list filter
      if (this.tournamentPlatform.length > 0) {
        var listTournamentPlatform = Object.keys(this.listTextFilter['tournamentPlatform']);
        for (var j = 0; j < listTournamentPlatform.length; j++) {
          var tournamentPlatform = listTournamentPlatform[j];
          if (this.tournamentPlatform.indexOf(tournamentPlatform) > -1) {
            this.listFilterSelected['tournamentPlatform.' + tournamentPlatform] = this.listTextFilter['tournamentPlatform'][tournamentPlatform];
          } else {
            delete this.listFilterSelected['tournamentPlatform.' + tournamentPlatform];
          }
        }
      } else {
        this.deleteAllKeyObject(this.listTextFilter['tournamentPlatform'], 'tournamentPlatform');
      }
      // add hub type to list filter
      if (this.hubType.length > 0) {
        var listHubType = Object.keys(this.listTextFilter['hubType']);
        for (var k = 0; k < listHubType.length; k++) {
          var hubType = listHubType[k];
          if (this.hubType.indexOf(hubType) > -1) {
            this.listFilterSelected['hubType.' + hubType] = this.listTextFilter['hubType'][hubType];
          } else {
            delete this.listFilterSelected['hubType.' + hubType];
          }
        }
      } else {
        this.deleteAllKeyObject(this.listTextFilter['hubType'], 'hubType');
      }
      // add newsletter filter to list filter
      if (this.enabledNewsFilter) {
        this.listFilterSelected['enabledNewsFilter'] = this.listTextFilter['enabledNewsFilter'];
      } else {
        delete this.listFilterSelected['enabledNewsFilter'];
      }
    },
    deleteAllKeyObject(objGet, prefix) {
      var listKeyObject = Object.keys(objGet);
      for (var i = 0; i < listKeyObject.length; i++) {
        delete this.listFilterSelected[prefix + '.' + listKeyObject[i]];
      }
    },
    async handleSearch(initial = false) {
      if (!initial) {
        this.changeRouteSearch();
      }
      this.tournaments = [];
      this.hubs = [];
      this.users = [];
      this.news = [];
      this.showLoading = true;
      this.$http.get('/handle-search', {
        params: {
          'query': this.keySearch,
          'featured': this.tournamentFeatured,
          'tournament_type': JSON.stringify(this.tournamentType),
          'platform': JSON.stringify(this.tournamentPlatform),
          'hub_type': JSON.stringify(this.hubType),
          'news_filter': this.enabledNewsFilter ? 1 : 0,
          'sort': this.filterSort,
          'list_total_results': JSON.stringify(this.listTotalResults),
          'in_page_search': 1,
          'page': this.currentPage,
        },
      })
        .then(response => {
          if (response.data.status === 0) {
            var result = response.data.result;
            this.totalResults = response.data.total_results;
            this.totalPages = response.data.total_pages;
            this.listTotalResults = response.data.list_total_results;
            this.tournaments = result.tournaments;
            this.hubs = result.hubs ? result.hubs : [];
            this.news = result.newsletters ? result.newsletters : [];
            // this.users = result.users ? result.users : [];
            this.showLoading = false;
          }
        })
        .catch(error => {
          console.log('handleSearch error request');
          console.log(error);
        });
    },
    handleFilterInPage(type, filterData) {
      this.startFilter = true;
      if (type === 'event') {
        this.tournamentFeatured = !filterData.featured ? 0 : 1;
        this.tournamentType = [];
        Object.keys(filterData.tournament_type).forEach(i => {
          if (filterData.tournament_type[i]) {
            this.tournamentType.push(i);
          }
        });
        this.tournamentPlatform = [];
        Object.keys(filterData.platform).forEach(i => {
          if (filterData.platform[i]) {
            this.tournamentPlatform.push(i);
          }
        });
        this.currentPage = 1;
        this.handleSearch();
      } else if (type === 'hub') {
        this.hubType = [];
        Object.keys(filterData).forEach(i => {
          if (filterData[i]) {
            this.hubType.push(i);
          }
        });
        this.currentPage = 1;
        this.handleSearch();
      } else if (type === 'news') {
        this.enabledNewsFilter = filterData ? 1 : 0;
        this.currentPage = 1;
        this.handleSearch();
      }
      this.handleSelectFilter();
    },
    toggleFilterDropdown() {
      this.showFilterDown = !this.showFilterDown;
    },
    changeSortFilter(filterSortBy) {
      this.filterSort = filterSortBy;
      this.showFilterDown = false;
      if (filterSortBy === 'newest') {
        this.filterSortText = 'Newest';
      } else if (filterSortBy === 'most_relevant') {
        this.filterSortText = 'Most Relevant';
      } else {
        this.filterSortText = filterSortBy;
      }
      this.handleSearch();
    },
    changeRouteSearch() {
      var enableNewsFilter = this.enabledNewsFilter ? 1 : 0;
      var url = this.appConfig.baseUrl + '/search?query=' + this.keySearch + '&featured=' + this.tournamentFeatured + '&news_filter=' + enableNewsFilter;
      if (this.tournamentType.length > 0) {
        url += '&tournament_type=' + JSON.stringify(this.tournamentType);
      }
      if (this.tournamentPlatform.length > 0) {
        url += '&platform=' + JSON.stringify(this.tournamentPlatform);
      }
      if (this.hubType.length > 0) {
        url += '&hub_type=' + JSON.stringify(this.hubType);
      }
      window.history.pushState('', '', url);
    },
    changePage(pageValue) {
      this.currentPage = pageValue;
      this.handleSearch();
    },
    checkPageDisplay(pageValue) {
      var currentPage = parseInt(this.currentPage);
      if (pageValue === 1 || pageValue === 2) {
        return pageValue;
      }
      // display 2 last page
      if (pageValue === this.totalPages || pageValue === this.totalPages - 1) {
        return pageValue;
      }

      var next10Page = currentPage + (this.number_max_page - 1);
      if (pageValue >= currentPage && pageValue <= next10Page) {
        return pageValue;
      }
      if (currentPage >= 4 && pageValue === currentPage - 1 && next10Page < this.totalPages - 1) {
        return '...';
      }
      if (pageValue === next10Page + 1) {
        return '...';
      }

      if (next10Page >= this.totalPages - 1 && (pageValue >= this.totalPages - 1 - this.number_max_page && pageValue <= this.totalPages - 2)) {
        if (pageValue === this.totalPages - 1 - this.number_max_page) {
          return '...';
        } else {
          return pageValue;
        }
      }
      return;
    },
    changePreviousPage() {
      var currentPage = parseInt(this.currentPage);
      var previousPage = currentPage - 1;
      if (previousPage <= 0) {
        previousPage = 1;
      }
      this.currentPage = previousPage;
      this.handleSearch();
    },
    changeNextPage() {
      var currentPage = parseInt(this.currentPage);
      var nextPage = currentPage + 1;
      if (nextPage <= 0) {
        nextPage = 1;
      }
      this.currentPage = nextPage;
      this.handleSearch();
    },
    closeFilter(filterKey, allowHandleSearch = 1) {
      delete this.listFilterSelected[filterKey];
      var filterKeyArr = filterKey.split('.');
      if (filterKeyArr.length === 2) {
        var index = this[filterKeyArr[0]].indexOf(filterKeyArr[1]);
        if (index > -1) {
          this[filterKeyArr[0]].splice(index, 1);
        }
      } else {
        this[filterKey] = 0;
      }
      this.initFilterData();
      if (allowHandleSearch) {
        this.handleSearch();
      }
    },
    clearFilter() {
      var self = this;
      Object.keys(this.listFilterSelected).forEach(function(filterKey) {
        self.closeFilter(filterKey, 0);
      });
      this.initFilterData();
      this.handleSearch();
    },
    initFilterData() {
      console.log('init filter data');
      this.filterData = {
        featured: this.tournamentFeatured ? 1 : 0,
        platform: this.tournamentPlatform,
        news_filter: this.enabledNewsFilter ? 1 : 0,
        tournament_type: this.tournamentType,
        hub_type: this.hubType,
      };
    },
  },
};
</script>

<style lang="scss">
    @import '../../styles/search/search.css';
</style>
